import Component from "vue-class-component";
import Vue from "vue";
import {AXIOS} from "@/lib/http-common";
import UserActionResultSender from "@/components/application/UserActionResultSender";
import {CommunicationTypes} from "@/components/properties/settings/communication/model/CommunicationTypes";
import {ConnectionData} from "@/components/properties/settings/communication/model/ConnectionData";
import {CubiscanVersion} from "@/components/properties/settings/communication/model/CubiscanVersion";
import {i18n} from "@/main";

@Component({
  computed: {
    CubiscanVersion() {
      return CubiscanVersion;
    },
    CommunicationTypes() {
      return CommunicationTypes;
    }
  }
})
export default class CommunicationSettingsView extends Vue {
  public loading: boolean = false;
  public updating: boolean = false;
  public testing: boolean = false;
  public databaseAddress: string = '';
  public databaseType: string = '';
  public databaseSerialPort: string = '5';
  public databaseCubiscanVersion: string = 'Cubiscan325';
  public address: string = '';
  public type: string = '';
  public serialPort: string = '5';
  public cubiscanVersion: string = 'Cubiscan325';
  public isCommunicationSettingsFormValid: boolean = false;

  public notEmpty = [(value: string) => {
    if (value) {
      return true;
    }

    return i18n.tc('global.rules.shouldNotBeEmpty');
  }];

  public validAddress = [(value: string) => {
    const addressPattern: string = '([\\d]{1,3}\\.[\\d]{1,3}\\.[\\d]{1,3}\\.[\\d]{1,3}):([\\d]{1,5})';
    const regex = new RegExp(addressPattern);
    const isValidAddress = regex.test(value);
    if (isValidAddress) {
      return true;
    }
    return 'Invalid address';
  }];

  public mounted() {
    this.getConnectionData();
  }

  public getConnectionData() {
    AXIOS.get(`/properties/connection-data`)
      .then((message) => {
        this.databaseAddress = message.data.ethernetAddress;
        this.databaseSerialPort = message.data.serialPort;
        this.databaseType = message.data.connectionMode;
        this.databaseCubiscanVersion = message.data.cubiscanVersion;

        this.address = message.data.ethernetAddress;
        this.serialPort = message.data.serialPort;
        this.type = message.data.connectionMode;
        this.cubiscanVersion = message.data.cubiscanVersion;
      })
      .catch(error => {
        UserActionResultSender.showErrorFeedback(error.response.data.responseCode);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  public testConnection() {
    this.testing = true;
    AXIOS.get(`/device/test-cubiscan-connection`, {params: {address: this.address}})
      .then((message) => {
        if (message.data) {
          UserActionResultSender.showSuccessFeedback('devices.communication.success.cubiScanConnectionTestSuccessful');
          return;
        }

        UserActionResultSender.showErrorFeedback('devices.communication.error.cubiScanConnectionTestError');
      })
      .catch(error => {
        UserActionResultSender.showErrorFeedback(error.response.data.responseCode);
      })
      .finally(() => {
        this.testing = false;
      });
  }

  public updateConnection() {
    this.updating = true;
    const connectionData: ConnectionData = {
      connectionMode: this.type,
      ethernetAddress: this.address,
      serialPort: this.serialPort,
      cubiscanVersion: this.cubiscanVersion
    };
    AXIOS.put(`/properties/connection-data`, connectionData)
      .then(() => {
        this.databaseType = this.type;
        this.databaseSerialPort = this.serialPort;
        this.databaseAddress = this.address;
        this.databaseCubiscanVersion = this.cubiscanVersion;
        UserActionResultSender.showSuccessFeedback('devices.communication.success.connectionEdited');
      })
      .catch(error => {
        UserActionResultSender.showErrorFeedback(error.response.data.responseCode);
      })
      .finally(() => {
        this.updating = false;
      });
  }
}
